import { api1, api3 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

export const getAssessmentGraph = async (occupationId, currentJob, description) => {
  try {
    const response = await api1.post(API_ENDPOINTS.GET_ASSESSMENT_DATA, {
      occupationId: occupationId,
      occupation: currentJob,
      description: description,
    }, 
    {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};

export const getMainstreamCareers = async (occupationId, currentJob, token) => {
  try {
    if (occupationId) {
      const response = await api1.post(API_ENDPOINTS.MAINSTREAM_CAREERS, {
        id: occupationId,
        occupation: currentJob,
        token: token
      }, 
      {
        meta: { showToast: false },
      });
      return response.data;
    } else {
      console.error("JobId is not available");
    }
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};

export const getSkillGapAssessment = async (designation, target, userId) => {
  try {
    const response = await api1.post("/api/skill-gap/get-skill-gap", {
      user_current_occupation: designation,
      user_target_occupation: target,
      user_id: userId,
    }, 
    {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    if (error.name === "AbortError") {
      return;
    }

    console.error(
      "Error while fetching data:",
      error.response?.data || error.message
    );

    throw error; 
  }
};


export const getAILiteracyQuiz = async (occupation, occupationDescription) => {
  try {
    const response = await api1.post(API_ENDPOINTS.GET_AI_LITERACY_QUIZ, {
      occupation,
      occupationDescription
    }, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching AI Literacy Quiz:", error);
    return null;
  }
};

export const getCourseList = async (targetJob, pages) => {
  try {
    const targetOccupation = typeof targetJob === 'object' ? targetJob.name || targetJob.occupation || JSON.stringify(targetJob) : targetJob;
    
    const response = await api3.post(API_ENDPOINTS.FILTER_COURESES, null, {
      params: { target_occupation: targetOccupation },
    });

    return response.data.courses;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getEmergingAI = async (occupationId, currentJob, description) => {
  try {
    const response = await api1.post("/api/emerging/get-emerging-ai", {
      occupationId: occupationId,
      occupation: currentJob,
      description: description,
    },
    {
      meta: { showToast: false },
    });

    return response?.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};

export const getAllMainstreamCareers = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_ALL_MAINSTREAM_CAREERS, {
      meta: { showToast: false },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching all mainstream careers:", error);
    return null;
  }
};

export const getAllEmergingCareers = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_ALL_EMERGING_CAREERS, {
      meta: { showToast: false },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching all emerging careers:", error);
    return null;
  }
};

export const getMenteesAppointments = async (userId) => {
  try {
    const response = await api1.get(`/api/meetings/appointments/${userId}`, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getMentorAppointments = async (userId) => {
  try {
    const response = await api1.get(
      `/api/meetings/appointments/mentor/${userId}`, {
        meta: { showToast: false },
      });
    return response.data?.menteeApplications;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getAllMentorAppointments = async (userId) => {
  try {
    const response = await api1.get(
      `/api/meetings/appointments/all/mentor/${userId}`, {
        meta: { showToast: false },
      });
    return response.data.menteeApplications;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getAllMenteeAppointments = async (userId) => {
  try {
    const response = await api1.get(
      `/api/meetings/appointments/${userId}`, {
        meta: { showToast: false },
      });
    return response.data.meetings;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getTools = async (currentJob, occupationId) => {
  try {
    const response = await api1.post(`/api/tools/get-tools`, {
      occupation: currentJob,
      occupationId: occupationId,
    },
    {
      meta: { showToast: false },
    });

    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getVirtualCourses = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_COURSE,  {
        meta: { showToast: false },
      });
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getVirtualCoursesByUserId = async (userId) => {
  try {
    const response = await api1.get(
      `${API_ENDPOINTS.GET_COURSE_BY_ID}/${userId}`, {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};
